import script from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=2027e864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2027e864"]])

export default __exports__